/**
 * Card name matcher with alias map for known misspellings.
 *
 * IMPORTANT: SPARTA aliases were intentionally REMOVED — the "This is Sparta"
 * stun-power bonus is now data-driven via on_attack_damage mechanic, so we
 * don't need a name alias for it.
 */
import type { Card } from "@/types/card";

export const NAME_ALIASES: Record<string, string> = {
  "spartacus, undefeated": "Spartacus, Undefeated",
  "spartacus undefeated": "Spartacus, Undefeated",
  "aegis the defiant": "Aegis the Defiant",
  soulreaver: "Soulreaver",
  "channel focus": "Channel Focus",
  "ignite blade": "Ignite Blade",
  "quick learner": "Quick Learner",
  "saving stamina": "Saving Stamina",
  "committed form": "Committed Form",
  "wound-bind cord": "Wound-Bind Cord",
  "wound bind cord": "Wound-Bind Cord",
  "vial of sparks": "Vial of Sparks",
  "fuel the inferno": "Fuel The Inferno",
  "battle adrenaline": "Battle Adrenaline",
  "tensed core": "Tensed Core",
  "scar-fueled focus": "Scar-Fueled Focus",
  "scar fueled focus": "Scar-Fueled Focus",
  "crushing strength": "Crushing Strength",
  "zeus' wrathbrand": "Zeus' Wrathbrand",
  "zeus wrathbrand": "Zeus' Wrathbrand",
  "zues' wrathbrand": "Zeus' Wrathbrand",
  "zues wrathbrand": "Zeus' Wrathbrand",
  "added pressure": "Added Pressure",
  "concussion ring": "Concussion Ring",
  "dance of blades": "Dance of Blades",
  "hardened hands": "Hardened Hands",
  "the first fight": "The First Fight",
  "handle bash": "Handle Bash",
  "unbroken sands": "Unbroken Sands",
  "hardened steel": "Hardened Steel",
  "thrusting release": "Thrusting Release",
  clobberation: "Clobberation",
  "fleeting cut": "Fleeting Cut",
};

export function canonicalName(name: string): string {
  const t = (name ?? "").toLowerCase().trim();
  return NAME_ALIASES[t] ?? name;
}

/** Compares card.name to a target through the alias map. */
export function nameMatches(card: Card | { name: string } | undefined | null, target: string): boolean {
  if (!card) return false;
  return canonicalName(card.name) === canonicalName(target);
}
